import { CSSProperties, ReactElement, ReactNode } from 'react';
import { ORBIT_DISABLED, ORBIT_GRAY } from '@/theme/colors';
import { formatLedgerMoney } from './ledgerRows';

/** The prototype's summary tables above a Finance ops list: the Ledger's and the Receivables'. */

const WRAP_STYLE: CSSProperties = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: 28,
  alignItems: 'flex-start',
  padding: '16px 12px',
  borderBottom: '1px solid rgba(0, 0, 0, 0.10)',
  background: '#fff',
};

const TABLE_STYLE: CSSProperties = { borderCollapse: 'collapse', fontVariantNumeric: 'tabular-nums' };

const CELL_STYLE: CSSProperties = {
  padding: '4px 14px 4px 0',
  fontSize: 12,
  lineHeight: '18px',
  textAlign: 'right',
  whiteSpace: 'nowrap',
  fontWeight: 400,
};

const WHO_STYLE: CSSProperties = { textAlign: 'left', paddingRight: 20 };
const TOTAL_STYLE: CSSProperties = { borderTop: '1px solid rgba(0, 0, 0, 0.10)', fontWeight: 600, paddingTop: 6 };

export function SummaryTables({ children }: { children: ReactNode }): ReactElement {
  return <div style={WRAP_STYLE}>{children}</div>;
}

export function SummaryTable({ label, children }: { label: string; children: ReactNode }): ReactElement {
  return (
    <table style={TABLE_STYLE} aria-label={label}>
      {children}
    </table>
  );
}

export function Head({ children, who }: { children: ReactNode; who?: boolean }): ReactElement {
  return <th style={{ ...CELL_STYLE, ...(who ? WHO_STYLE : {}), color: ORBIT_GRAY, fontWeight: 500 }}>{children}</th>;
}

export function Who({ children, total }: { children: ReactNode; total?: boolean }): ReactElement {
  return <td style={{ ...CELL_STYLE, ...WHO_STYLE, ...(total ? TOTAL_STYLE : {}) }}>{children}</td>;
}

export function Amount({
  value,
  sign,
  bold,
  total,
}: {
  value: number;
  sign?: boolean;
  bold?: boolean;
  total?: boolean;
}): ReactElement {
  const zero = value === 0;
  return (
    <td
      style={{
        ...CELL_STYLE,
        ...(total ? TOTAL_STYLE : {}),
        ...(bold ? { fontWeight: 600 } : {}),
        color: zero ? ORBIT_DISABLED : 'black',
      }}
    >
      {zero ? '—' : formatLedgerMoney(value, { sign })}
    </td>
  );
}

export function Count({ value, total }: { value: number; total?: boolean }): ReactElement {
  return <td style={{ ...CELL_STYLE, ...(total ? TOTAL_STYLE : {}) }}>{value}</td>;
}
